// extracted by mini-css-extract-plugin
module.exports = {"text":"ConfirmDialog_text__3WU8L","buttonsContainer":"ConfirmDialog_buttonsContainer__1vlUh"};